import React, {useState} from "react";
import { Helmet } from "react-helmet";
import {Header, Titulo, 
   // ContenedorHeader, ContenedorBotones
} from './../elementos/Header';
import BtnRegresar from "../elementos/BtnRegresar";
import FormularioCancelarViaje from "./FormularioCancelarViaje";
import FormularioViajePasajero from "./FormularioCreaViajePasajero";
import {ContenedorDoble} from '../elementos/ElementosDeFormularioCreaViaje';
import {useParams} from 'react-router-dom'
import useObtenerViajeId from './../hooks/useObtenerViajeId'

const  EditarViaje = () => {
    const {id} = useParams();
    const [itinerario, cambiarItinerario] = useState([]); 
    const [listadoPasajeros, cambiarListadoPasajeros] = useState([]); 
    const viaje = useObtenerViajeId({id});
    //console.log(viaje.itinerario)

    return ( 
        <>
        <Helmet>
        <title> Cancelar Viaje  </title>
        </Helmet>
            <Header>
                <BtnRegresar></BtnRegresar>
                <Titulo>Cancelar Viaje </Titulo>         
            </Header>
            <ContenedorDoble>
            <FormularioCancelarViaje 
                id={id}
                viaje={viaje}
                itinerario={itinerario} 
                cambiarItinerario={cambiarItinerario} 
                listadoPasajeros={listadoPasajeros} 
                cambiarListadoPasajeros={cambiarListadoPasajeros} 
            >
            </FormularioCancelarViaje>

            </ContenedorDoble>
        
            

        
 
        </>

     );
}
 
export default  EditarViaje;